"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKindEquivalency = exports.getClassName = void 0;
var _constants = require("./constants");
var KIND_EQUIVALENCIES = {
  success: 'positive',
  error: 'critical',
  attention: 'warning',
  grey: 'default',
  primary: 'default'
};

// TODO: Remove this export, only kept to avoid breaking change
var getKindEquivalency = exports.getKindEquivalency = function getKindEquivalency(color) {
  return KIND_EQUIVALENCIES[color.toLowerCase()] || 'default';
};
var getClassName = exports.getClassName = function getClassName(currentTransition) {
  return currentTransition ? "".concat(_constants.CLASSNAME_ANIMATION, "--").concat(currentTransition) : '';
};